<template>
  <div>
    <!-- 主体部分 -->
    <template>
      <report-release-note v-if="platName!=='singleCell'"></report-release-note>
      <!-- 组学智能体 Pro：表格上方的宣传卡片 + 海报弹窗 -->
      <ai-agent-entry v-if="isAiPromoPlatform" @open="openAiPromo"></ai-agent-entry>
      <ai-agent-drawer
          v-if="isAiPromoPlatform"
          ref="aiAgentDrawer"
          :platform="aiPlatformKey"
          :system-type="systemType"
          @never-show="handlePromoNeverShow"></ai-agent-drawer>
      <slot name="button">
      </slot>
      <w-table class="wMyTable" ref="wMyTable" :columns="columns" :table-data="projectData"
               :isUseInnerSearch="platName==='singleCell'"
               @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
               :table-col-check="tableColCheck"
               :page="page" @pageChange="handlePagePagination">
        <span slot="projectId" slot-scope="{text,record}">
          <span v-if="judgeProjectLock(record)">
            <span v-if="judgeProjectLockIcon(record)" class="projectLockIcon">
               <el-tooltip content="分析结果未释放">
                 <a-icon type="lock"/>
               </el-tooltip>
            </span>
            <a @click="getProjectInfo(text,record)">{{ text }}</a>
            <el-tooltip content="复制">
              <a-icon type="copy" style="color: #76bb5f;margin-left: 3px" @click="copyText(text)"/>
<!--              <i style="color:#447c24;font-size: 16px;margin-left: 5px;cursor: pointer " class="el-icon-document-copy" @click="copyText(text)"></i>-->
            </el-tooltip>
          </span>
          <el-tooltip v-else content="分析结果未释放，项目不可查看">
            <span style="cursor:pointer;color: rgba(143,146,153,0.8)"><a-icon class="projectLockIcon" type="lock"/>{{ text }}
              <el-tooltip content="复制">
                 <a-icon type="copy" style="color: #76bb5f" @click="copyText(text)"/>
            </el-tooltip></span>
          </el-tooltip>
        </span>
        <span slot="bsSignStatus" slot-scope="{text,record}">
          <div v-if="text">
            <el-tag :type="['SIGNED','AUTO'].includes(text)?'success':'danger'">{{ bsContractChEn[text] }}</el-tag>
          </div>
        </span>
        <span slot="customerName" slot-scope="{text,record}">
          {{ text ? Array.from(new Set(text.map(item => item.realName))).join(';') : '' }}
        </span>
        <span slot="salesName" slot-scope="{text,record}">
             {{ text.map(item => item.name).join(';') }}
        </span>
        <!--        样本信息-->
        <span slot="sampleInfo" slot-scope="{text,record}">
          <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record)">查看样本
            <i class="viewIcon" v-html="viewDetailIcon"></i></span>
        </span>
        <!--       折叠-->
        <div slot="foldInfo" slot-scope="{text, record, index}">
          <ex-fold-table-cell :scope="{text:text.split('|'), record, index}"></ex-fold-table-cell>
        </div>
        <span slot="projectSign" slot-scope="{text,record}">
         <slot name="projectSign" v-bind="{text,record}"></slot>
        </span>
        <!--        报告审批状态-->
        <span slot="passApproval" slot-scope="{text,record}">
          <el-tag :type="text?'success':'info'">{{ text ? '通过' : '待审批' }}</el-tag>
        </span>
        <span slot="resReleased" slot-scope="{text,record}">
          <el-tag :type="record?.projectsRow?.bsReleased&&record?.projectsRow?.resReleased?'success':'info'">{{
              (record?.projectsRow?.bsReleased && record?.projectsRow?.resReleased) ? '已释放' : '未释放'
            }}</el-tag>
        </span>
        <div slot="note" slot-scope="{text, record,column}">
          <div style="display: flex;align-items: center">
            <el-tooltip content="修改备注">
              <i class="el-icon-edit" style="color: green;cursor: pointer" v-has-permission="'project_edit'"
                 @click="handleShowUpdateDialog(record,'note')"></i>
            </el-tooltip>
            <div>
                <span v-html="computerNote(text)">
                </span>
              <el-tooltip content="显示更多信息">
                <span v-if="text?text.length>30:false" @click="handleShowUpdateDialog(record,'note')"
                      style="font-size: 11px;cursor: pointer">......</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div slot="customNote" slot-scope="{text, record,column}">
          <div style="display: flex;align-items: center">
            <el-tooltip content="修改备注">
              <i class="el-icon-edit" style="color: green;cursor: pointer"
                 v-if="record.customerList.map(item=>item.id).includes(Number($store.getters['right/getUser']?.customer?.id))||['ADMIN','MANAGER'].includes($store.getters['right/getRole'])"
                 @click="handleShowUpdateDialog(record,'customerRemark')"></i>
            </el-tooltip>
            <div>
                <span v-html="computerNote(text)">
                </span>
              <el-tooltip content="显示更多信息">
                <span v-if="text?text.length>30:false" @click="handleShowUpdateDialog(record,'customerRemark')"
                      style="font-size: 11px;cursor: pointer">......</span>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div slot="rawDataStatus" slot-scope="{text, record}">
          <span :class="rawDataStatusIconList[text]?.class">
            {{ rawDataStatusIconList[text].displayName }}
          </span>
        </div>
        <div slot="mergeStatus" slot-scope="{text, record}">
          <span>
            <el-tag style="width: 80px;height: 28px;text-align: center;padding-top: 4px" round size="mini" effect="dark"
                    :type="getMergeStatusType(text)">{{ getMergeStatusText(text) }}</el-tag>
            <el-tooltip v-if="text === 2 && record.mergeProjectList && record.mergeProjectList.length > 0"
                        placement="top"
                        effect="light">
              <div slot="content">
                <div style="max-height: 200px; overflow-y: auto;">
                  <p style="margin: 0 0 5px 0; font-weight: bold;">合并的原始项目列表：</p>
                  <div v-for="(project, index) in record.mergeProjectList" :key="index">
                    {{ project }}
                  </div>
                </div>
              </div>
              <i class="el-icon-question" style="margin-left: 5px; color: #909399; cursor: pointer;"></i>
            </el-tooltip>
          </span>
        </div>
        <div slot="filterMergeStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
             style="padding: 8px; position: relative; z-index: 9999 !important;">
          <div style="padding: 0px 15px">
            <el-radio-group v-model="selectedKeys[0]">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="未合并">未合并</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio label="已合并">已合并</el-radio>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="合并项目">合并项目</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>
          </div>
          <div style="display: flex;padding: 15px">
            <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
            </a-button>
          </div>
        </div>
        <div slot="filterProjectType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
             style="padding: 8px; position: relative; z-index: 9999 !important;">
          <div style="padding: 0px 15px">
            <el-radio-group v-model="selectedKeys[0]">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="normal">normal</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio label="binning">binning</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>
          </div>
          <div style="display: flex;padding: 15px">
            <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
            </a-button>
          </div>
        </div>
        <div slot="filterRawDataStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
             style="padding: 8px; position: relative; z-index: 9999 !important;">
          <div style="padding: 0px 15px">
            <el-radio-group v-model="selectedKeys[0]">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="无">无</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio label="未释放">未释放</el-radio>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="链接释放">链接释放</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio label="硬盘释放">硬盘释放</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>
          </div>
          <div style="display: flex;padding: 15px">
            <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
            </a-button>
          </div>
        </div>
        <div slot="operation" slot-scope="{text, record}">
          <el-button type="warning" size="mini" v-has-permission="'project_changer_user'" @click="handleChange(record)">
            更改用户
          </el-button>
          <el-popconfirm
              v-if="record.projectsRow.rawDataStatus==='NOT_RELEASED'&&record.soleKeyList.length===0&&['ADMIN', 'MANAGER', 'AUDIT'].includes($store.getters['right/getRole'])"
              confirm-button-text='同意释放'
              cancel-button-text='取消'
              icon-color="#d07b7b"
              title="你同意释放该项目的原始数据吗？"
              @confirm="releaseRowData(record)">
            <el-button
                type="success" size="mini"
                slot="reference" style="margin-left: 10px">释放数据
            </el-button>
          </el-popconfirm>
            <el-button v-has-permission="'projects_share'" style="margin-left: 10px"
                       size="mini"
                       type="primary"
                       @click="handleShare(record)">分享
            </el-button>
          <el-button style="margin-left: 10px" type="danger" size="mini" v-has-permission="'project_del'"
                     @click="handleDeleteProject(record)">删除
          </el-button>
        </div>
      </w-table>
    </template>
    <!--    修改项目信息-->
    <edit-form-info-dialog v-if="showUpdateDialog" :show-dialog.sync="showUpdateDialog"
                           :select-detail="updateProjectData"
                           @submitData="updateProject"></edit-form-info-dialog>
    <!--    图片，加载中-->
    <picture-loading v-if="loadingProject"></picture-loading>
    <!--    更换用户-->
    <change-users v-if="showUserDialog" :show-dialog="showUserDialog" :select-detail="updateProjectUserData"
                  @submit="submitProjectUser"></change-users>
    <!--    分享管理-->
    <share-customer-manager-dialog v-if="showShareCusDialog" :select-detail="selectDetail"
                                   :platform="platName.toLocaleUpperCase()"
                                   :show-dialog="showShareCusDialog"
                                   @submit="closeShareCusDialog"></share-customer-manager-dialog>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
  </div>
</template>


<script>
import {addT} from '@/utils/utils'
import Upload from '@/components/Upload'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import PictureLoading from "@/components/customerTable/PictureLoading";
import LoadingDialog from "@/components/LoadingDialog";
import {tableOperationMixin} from "@/mixins/tableOperation";
import {
  projectCustomerEdit,
  projectChangeUser,
  projectList,
  projectRelease,
  projectDel,
  projectEdit,
  analyzePage
} from "@/api/project";
import AiAgentDrawer from "@/components/aiPromo/AiAgentDrawer.vue";
import AiAgentEntry from "@/components/aiPromo/AiAgentEntry.vue";
import {isChatAiPromoHidden, hideChatAiPromo} from "@/utils/chatAiPromo";
import ChangeUsers from "@/components/ChangeUsers";
import {columnsData} from "@/utils/data/tableCol/transTableCol";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import ShareCustomerManagerDialog from "@/components/ShareCustomerManagerDialog";
import {bsContractChEn, getRawDataStatusChByEn, getRawDataStatusEnByCh, rawDataStatusColor} from "@/utils/ch_en_trans";
import {viewDetailIcon} from "@/utils/iconUtils";
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import {rawDataStatusIconList} from "@/utils/data/basicData/rawDataStatusData";
import EditFormInfoDialog from "@/components/EditFormInfoDialog.vue";
import ReportReleaseNote from "@/components/ReportReleaseNote.vue";
import {MODULES, projectColumns} from "@/utils/data/tableCol/projectTableCol";
import {getBsInfoByContract} from "@/api/dilivery/bs";
import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";
import {copyText} from "@/utils/windowsUtils";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: 'projectIndex',
  props: {
    tableColCheck: { isShow: false, name: '' },
    platName: { default: 'trans' },
    systemType: { default: 'diversity' },
  },
  components: {
    ReportReleaseNote,
    EditFormInfoDialog,
    SampleInfoDialog,
    ShareCustomerManagerDialog,
    LoadingDialog,
    PictureLoading,
    'upload': Upload,
    ChangeUsers,
    ExFoldTableCell,
    AiAgentDrawer,
    AiAgentEntry
  },
  mixins: [tableOperationMixin],
  data() {
    return {
      viewDetailIcon,
      rawDataStatusIconList,
      showUserDialog: false,
      showUpdateDialog: false,
      showShareCusDialog: false,
      showDetailDrawer: false,
      currentDetailProject: {},
      updateProjectData: { projectId: '', category: '', note: '' },
      updateProjectUserData: {
        projectId: '', selectedSalers: [], selectedAnalyze: '', selectedCustomers: [], selectedCustomersInfo: []
      },
      loadingProject: true,
      page: { total: 0, pageSize: 10, currentNum: 1 },
      projectData: [],
      selectDetail: '',
      sampleInfoDialog: false,
      bsContractChEn
    }
  },
  computed: {
    // 只有这几个系统的页面才展示组学智能体 Pro（且自动弹窗需要已有项目和分析）
    isAiPromoPlatform() {
      return ['trans', 'metabo', 'metag', 'bz'].includes(this.platName)
    },
    // 组学智能体的系统标识：bz 下再区分「多样性」/「功能基因扩增子」
    aiPlatformKey() {
      if (this.platName === 'bz') {
        return this.systemType === 'funcGene' ? 'bzFun' : 'bz'
      }
      return this.platName
    },
    columns() {
      let role = this.$store.getters["right/getRole"]
      let column
      column = projectColumns(this.searchConditionTag || []).filter(column => (!column.model || column.model.includes(this.platName))&&!column?.noPermitRole?.includes(role))
        if (['ANALYST', 'TECH'].includes(this.$store.getters["right/getRole"])) {
          column.splice(column.length - 1, 1)
        }
      return column
    }
  },
  mounted() {
    this.getData()
    this.maybeShowAiPromo()
  },
  methods: {
    // ---------------- 组学智能体 Pro 宣传 ----------------
    // 点击宣传卡片：直接进入“选择项目号/分析”那一页
    openAiPromo() {
      if (this.$refs.aiAgentDrawer) this.$refs.aiAgentDrawer.open('picker')
    },
    // 用户选择“不再提示”：按 用户+平台 持久化，并告知之后从右下角卡片进入
    handlePromoNeverShow() {
      hideChatAiPromo(this.aiPlatformKey)
      if (this.$refs.aiAgentDrawer) this.$refs.aiAgentDrawer.close()
      this.$messageUi.success('已关闭自动提示，可点击页面右上角的凌博士头像随时进入')
    },
    // 只有当前系统里有项目号、且存在分析时才自动打开宣传抽屉
    async maybeShowAiPromo() {
      if (!this.isAiPromoPlatform || isChatAiPromoHidden(this.aiPlatformKey)) return
      const buildSendData = () => {
        const condition = {}
        // bz 平台需要区分多样性与功能基因扩增子
        if (this.platName === 'bz') condition.systemType = this.systemType
        return {page: {current: 1, size: 1}, condition, sorts: []}
      }
      try {
        const [projectRes] = await Promise.all([
          projectList(buildSendData(), this.platName).catch(() => null),
        ])
        if (this.pageHasData(projectRes)) {
          this.$nextTick(() => {
            if (this.$refs.aiAgentDrawer) this.$refs.aiAgentDrawer.open('poster')
          })
        }
      } catch (e) {
        // 静默失败，不影响页面
      }
    },
    // 兼容分页返回结构：数组 / { data: [] } / { records: [] }
    pageHasData(res) {
      if (!res || (res.code && res.code !== 200) || !res.data) return false
      const data = res.data
      if (Array.isArray(data)) return data.length > 0
      const list = Array.isArray(data.data) ? data.data : (Array.isArray(data.records) ? data.records : [])
      const total = Number(data.totalNum || data.total || list.length)
      return total > 0 || list.length > 0
    },

    //获取项目列表
    async getData(isInt) {
      this.loadingProject = true
      var sendData = {
        page: {
          current: this.page.currentNum,
          size: this.page.pageSize,
        }
      }
      if (isInt) {
        sendData.page.current = 1
        sendData.page.size = 10
      }
      let length = this.searchConditionTag.length


      if (length) {
        sendData.condition = {}
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'createTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            sendData.condition.createTime = [addT(value1), addT(value2)]
          } else if (key === 'projectSign') {
            sendData.condition.projectSign = item.value.includes('normal') ? 'normal' : 'binning'
          } else if (key === 'rawDataStatus') {
            sendData.condition.rawDataStatus = getRawDataStatusEnByCh(item.value)
          } else {
            sendData.condition[key] = item.value
          }
        })
      } else {
        sendData.condition = {}
      }
      if(this.platName === 'bz'){
        sendData.condition.systemType = this.systemType
      }
      sendData.sorts = this.sortConditionTag
        projectList(sendData, this.platName).then(async res => {
          if (res.code === 200) {
            const contractInfoRes = await getBsInfoByContract(res.data.data.map(item => item?.projectsRow?.contractNumber).filter(item => item))
            if (contractInfoRes.code === 200) {
              const contractInfo = contractInfoRes.data
              var pageData = res.data
              this.projectData = pageData.data.map(item => {
                return {
                  ...item,
                  bsSignStatus: (contractInfo) ? (contractInfo[item?.projectsRow?.contractNumber]?.signStatus) : ''
                }
              })
              this.loadingProject = false
              this.page.total = pageData.totalNum
              this.page.pageSize = pageData.pageSize
              this.page.currentNum = pageData.currentNum
            }
          }
        })


    },
    //获取tag的搜索排序的内容
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    //页码的变动
    handlePagePagination(page) {
      this.loading = true
      this.page.currentNum = page.currentNum
      if (page.pageSize) {
        this.page.pageSize = page.pageSize
      } else {
        this.page.pageSize = this.page.total
      }
      this.getData()
    },
    //根据备注的长度调整展示的内容
    computerNote(text) {
      if (text) {
        if (text.length <= 30) {
          return text
        } else {
          return text.substring(0, 30)
        }
      } else {
        return ''
      }
    },
    //备注框的长度限制
    limitLength(value) {//value 为获取到的输入框的值
      this.exceedMax = value.length === 100
    },
    //获取原始数据状态
    getRawStatus(status) {
      return getRawDataStatusChByEn(status)
    },
    //获取原始数据状态tag颜色
    getRawStatusColor(status) {
      return rawDataStatusColor[status]
    },
    // 获取合并状态颜色
    getMergeStatusType(status) {
      switch (Number(status)) {
        case 0:
          return '';
        case 1:
          return 'danger';
        case 2:
          return 'info';
        default:
          return 'warning';
      }
    },
    // 获取合并状态文本
    getMergeStatusText(status) {
      switch (Number(status)) {
        case 0:
          return '未合并';
        case 1:
          return '已合并';
        case 2:
          return '合并项目';
        default:
          return '未知状态';
      }
    },
    // 提交释放原始数据申请
    releaseRowData(record) {
      const projectId = record.projectsRow.projectId
      projectRelease(projectId, this.platName).then(res => {
        if (res.code === 200) {
          this.$message.success("释放成功")
          this.getData()
        }
      })
    },
    //点击删除项目
    async handleDeleteProject(record) {
      const projectId = record.projectsRow.projectId
      this.$confirmUi('此操作将会永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        projectDel(projectId, this.platName).then(res => {
          if (res.code === 200) {
            this.$message.success("删除成功")
            this.avoidPageByDel()
            this.getData()
          }
        })
      }).catch(() => {
      })
    },
    //防止删除时该页面只有一条数据，删除后页面不回上一页
    avoidPageByDel() {
      this.$message.success("删除成功")
      const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
      this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
      this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
    },
    /** 更换用户按钮操作 */
    handleChange(row) {
      this.updateProjectUserData.selectedSalers = row.salerList.map(item => {
        return item.uuid[0]
      })
      this.updateProjectUserData.selectedCustomers = row.customerList.map(item => {
        return item.emailAccount
      })
      this.updateProjectUserData.selectedCustomersInfo = row.customerList
      this.updateProjectUserData.selectedAnalyze = row.analyst ? row.analyst.uuid[0] : ''
      this.updateProjectUserData.projectId = row.projectsRow.projectId
      this.showUserDialog = true
    },
    //提交更换用户的信息
    submitProjectUser(data, type) {
      this.showUserDialog = false
      if (type !== 'cancel') {
        let sendData = {
          "projectId": data.projectId,
          "analystId": data.selectedAnalyze,
          "salesIds": data.selectedSalers,
          "customerIds": data.customerIds
        }
        projectChangeUser(sendData, this.platName).then(res => {
          if (res) {
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.getData()
            }
          }
        })
      }
    },
    //点击修改项目类型
    handleShowUpdateDialog(project, type) {
      this.updateProjectData.projectId = project.projectsRow.projectId
      this.updateProjectData.title = '编辑信息'
      this.updateProjectData.form = {}
      switch (type) {
        case 'note':
          this.updateProjectData.title = '编辑备注'
          this.updateProjectData.form.note = {
            value: project.projectsRow.note,
            type: 'textarea',
            label: '备注'
          }
          break;
        case 'customerRemark':
          this.updateProjectData.title = '编辑备注'
          this.updateProjectData.form.customerRemark = {
            value: project.customerRemark,
            type: 'textarea',
            label: '备注'
          }
          break;
        case 'category':
          this.updateProjectData.title = '编辑类型'
          this.updateProjectData.form.note = {
            value: project.projectsRow.category,
            type: 'input',
            label: '类型'
          }
          break;
      }
      this.showUpdateDialog = true
    },
    //提交项目信息的修改
    async updateProject(data) {
      let sendData = {projectId: data.projectId}
      Object.keys(data.form).forEach(key => {
        sendData[key] = data.form[key].value
      })
      let res
      if (data.form.hasOwnProperty('customerRemark')) {
        res = await projectCustomerEdit(sendData, this.platName)
      } else {
        res = await projectEdit(sendData, this.platName)
      }

      this.showUpdateDialog = false
      if (res) {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.$nextTick(() => {
            this.getData()
          })

        } else {
          this.$message.error('修改失败')
        }
      }
    },
    judgeProjectLock(row) {
      if (['USER', 'SALES'].includes(this.$store.getters["right/getRole"])) {
        return row?.projectsRow?.bsReleased && row?.projectsRow?.resReleased
      } else {
        return true
      }
    },
    judgeProjectLockIcon(row) {
      return !(row?.projectsRow?.bsReleased && row?.projectsRow?.resReleased)
    },
    //跳转到具体的项目
    getProjectInfo(projectId, row) {
      switch (this.platName) {
        case 'bz':
          window.open('/bzWeb/desc?projectId=' + projectId)
          break;
        case 'trans':
          window.open('/transWeb/desc?projectId=' + projectId)
          break;
        case 'metag':
          if (row?.version?.value === 'v3') {
            window.open('/metagWeb_v3/desc?projectId=' + projectId)
          } else {
            window.open('/metagWeb/desc?projectId=' + projectId)
          }
          break;
        case 'metabo':
          window.open('/metaboWeb/desc?projectId=' + projectId)
          break;
        case 'singleCell':
          window.open('http://sc.biozeron.com/cloud-process-lite/transcriptome/result/a7d40fd8-9372-427e-816d-3a0f7597e8fe/conclusion?token=ak_zeron_yEDPP6vUsWTXMBb2utj4DtPJFWcb1FQIhbHZioEWcESHbrb-asjW6Np44osfHD-IPkTOzJquQ2mEGO7yfg5cMcK_L5tVu_wpFgARfVFRA18XoAfTE_Unvmy-qY8CIvfzJSdqNB5T6mLzRmObJQ1hcNCtaEan_F6h5BbLe1parSo_shbcmqmeK7RykahTv55SQ9gGkxUjwDAXZMS7QD19muSSr71Ym3fW8iVglNWnNg_LjfyIgnk2Wm6Sxg1wQ1zfw1yxAdMiyBlv9UpWsH-6XLDIAXcB2khLVw')
          break;
      }


    },
    checkCustomerPerm(record) {
      const role = this.$store.getters["right/getRole"];
      if(role!=='USER'){
        return true
      }
      const userId = this.$store.getters["right/getUser"]?.customer?.id;
      return (record?.customerInfos || []).map(item => item.id).includes(userId)
    },
    //分享项目
    handleShare(row) {
      this.selectDetail = {
        projectId: row.projectsRow.projectId,
        customerList: row.customerList
      }
      this.showShareCusDialog = true
    },
    //关闭分享
    closeShareCusDialog() {
      this.showShareCusDialog = false
    },
    lookSampleInfo(row) {
      let platform
      switch (this.platName) {
        case 'bz':
          platform = 'AMPLICON'
          break;
        case 'trans':
          platform = 'TRANS'
          break;
        case 'metag':
          platform = 'METAG'
          break;
        case 'metabo':
          platform = 'METABO'
          break;
      }
      this.selectDetail = {
        projectId: row.projectsRow.projectId,
        platform: platform
      }
      this.sampleInfoDialog = true
    },
    copyText(text){
      copyText(text)
      this.$messageUi.success('复制成功！')
    },
    //mixin
    addLoading() {
      this.loadingProject = true
    },
    updatePageDataBySearch() {
      this.page.currentNum = 1
      this.getData('search')
    },
    updatePageData() {
      this.getData('search')
    }
  }
}
</script>

<style scoped>
::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap;
}

/deep/ .wMyTable .ant-table-body {
  max-height: 700px !important;
}

/deep/ .viewIcon i {
  color: #2978ca !important;
}
</style>

